export default __webpack_public_path__ + "static/juice4-c76359a2282ad00f462dd800f36af975.png";